"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";

const Tips = () => {
  return (
    <div>
      <section className="py-16 bg-blue-100">
        <div className="max-w-screen-xl mx-auto">
          <p className=" text-6xl text-black font-bold text-center ">
            Our Events
          </p>

          {/* Grid for the event cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-6">
            {/* High-Profile Conferences Card */}
            <div className="bg-white text-black ">
              <div>
                <img
                  alt=""
                  src="/images/high-profile-conferences.jpg"
                  className=" object-cover mx-auto"
                  width={1400}
                  height={573}
                />
              </div>
              <div className="p-6">
                <p className="text-xl font-bold mb-4 text-left">
                  HIGH-PROFILE CONFERENCES
                </p>
                <p>
                  Organized industry-leading conferences for global clients,
                  seamlessly integrating keynote speakers, breakout sessions,
                  and networking events. Our crowning achievement? The Annual
                  Thome Seminar – a 2-day event featuring 20+ speakers and 50
                  exhibitors.
                </p>
              </div>
            </div>

            {/* Product Launches Card */}
            <div className="bg-white text-black  ">
              <div>
                <img
                  alt=""
                  src="/images/product-launches.jpg"
                  className=" object-cover mx-auto"
                  width={1400}
                  height={573}
                />
              </div>
              <div className="p-6">
                <p className="text-xl font-bold mb-4 text-left">
                  PRODUCT LAUNCHES
                </p>
                <p>
                  Transformed venues with unique themes, from marine-inspired
                  décor to Bollywood extravaganzas, creating immersive and
                  memorable launch events handling over 400 guests.
                </p>
              </div>
            </div>

            {/* Press Conferences & Gala Dinners Card */}
            <div className="bg-white text-black">
              <div>
                <img
                  alt=""
                  src="/images/press-conferences-gala-dinners.jpg"
                  className=" object-cover mx-auto"
                  width={1400}
                  height={573}
                />
              </div>
              <div className="p-6">
                <p className="text-xl font-bold mb-4 text-left">
                  PRESS CONFERENCES & GALA DINNERS
                </p>
                <p>
                  Managed prestigious press conferences, including one for
                  ONGC’s Maritime Summit, followed by a golf tournament and an
                  elegant gala dinner, offering the perfect mix of business and
                  networking opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className=" py-10 md:py-20 lg:py-24">
        <div className="max-w-screen-xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 lg:gap-10 items-stretch justify-between text-white">
            <div className="bg-blue-700 p-6 lg:p-10 rounded-md">
              <div className="bg-red-600 hover:bg-blue-700 p-4 rounded-full w-fit border-4 border-white -mt-20 mb-6">
                <img
                  src="/images/ico-profile.png"
                  className="object-cover w-12 h-12"
                  alt=""
                />
              </div>
              <h5 className="font-sans font-bold my-4">
                High-Profile Conferences
              </h5>
              <p>
                Organized industry-leading conferences for global clients,
                seamlessly integrating keynote speakers, breakout sessions, and
                networking events. Our crowning achievement? The Annual Thome
                Seminar – a 2-day event featuring 20+ speakers and 50
                exhibitors.
              </p>
            </div>
            <div className="bg-blue-700 p-6 lg:p-10 rounded-md">
              <div className="bg-red-600 hover:bg-blue-700 p-4 rounded-full w-fit border-4 border-white -mt-20 mb-6">
                <img
                  src="/images/ico-launch.png"
                  className="object-cover w-12 h-12"
                  alt=""
                />
              </div>
              <h5 className="font-sans font-bold my-4">Product Launches</h5>
              <p>
                Transformed venues with unique themes, from marine-inspired
                décor to Bollywood extravaganzas, creating immersive and
                memorable launch events handling over 400 guests.
              </p>
            </div>
            <div className="bg-blue-700 p-6 lg:p-10 rounded-md">
              <div className="bg-red-600 hover:bg-blue-700 p-4 rounded-full w-fit border-4 border-white -mt-20 mb-6">
                <img
                  src="/images/ico_package.png"
                  className="object-cover w-12 h-12"
                  alt=""
                />
              </div>
              <h5 className="font-sans font-bold my-4">
                Press Conferences & Gala Dinners
              </h5>
              <p>
                Managed prestigious press conferences, including one for ONGC’s
                Maritime Summit, followed by a golf tournament and an elegant
                gala dinner, offering the perfect mix of business and networking
                opportunities.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Tips;
